import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { Page404Component } from "./pages/authentication/page404/page404.component";
import { AuthGuard } from "./core/guard/auth.guard";
import { AuthLayoutComponent } from "./layout/app-layout/auth-layout/auth-layout.component";
import { MainLayoutComponent } from "./layout/app-layout/main-layout/main-layout.component";
const routes: Routes = [
    {
        path: "",
        redirectTo: "authentication/signin",
        pathMatch: "full",
    },
    {
        path: "authentication",
        component: AuthLayoutComponent,
        loadChildren: () =>
            import("./pages/authentication/authentication.module").then(
                (m) => m.AuthenticationModule
            ),
    },
    {
        path: "",
        component: MainLayoutComponent,
        canActivate: [AuthGuard],
        children: [

            {
                path: "dashboard",
                loadChildren: () =>
                    import("./dashboard/dashboard.module").then(
                        (m) => m.DashboardModule
                    ),
            },

            {
                path: "user_role_categories",
                loadChildren: () =>
                    import(
                        "./user_role_categories/user_role_categories.module"
                    ).then((m) => m.UserRoleCategoriesModule),
            },
            {
                path: "users",
                loadChildren: () =>
                    import("./pages/users/users.module").then(
                        (m) => m.UsersModule
                    ),
            },
            {
                path: "databases",
                loadChildren: () =>
                    import("./pages/databases/databases.module").then(
                        (m) => m.DatabasesModule
                    ),
            },
            {
                path: "modules",
                loadChildren: () =>
                    import("./pages/modules/modules.module").then(
                        (m) => m.ErpModulesModule
                    ),
            },

            {
                path: "screens",
                loadChildren: () =>
                    import("./pages/screens/screens.module").then(
                        (m) => m.ScreensModule
                    ),
            },
            {
                path: "actions",
                loadChildren: () =>
                    import("./pages/actions/actions.module").then(
                        (m) => m.ActionsModule
                    ),
            },
            {
                path: "groups",
                loadChildren: () =>
                    import("./pages/groups/groups.module").then(
                        (m) => m.GroupsModule
                    ),
            },
            {
                path: "divisions",
                loadChildren: () =>
                    import("./pages/divisions/division.module").then(
                        (m) => m.DivisionModule
                    ),
            },
            {
                path: "departments",
                loadChildren: () =>
                    import("./pages/departments/department.module").then(
                        (m) => m.DepartmentModule
                    ),
            },
            {
                path: "sections",
                loadChildren: () =>
                    import("./pages/sections/section.module").then(
                        (m) => m.SectionModule
                    ),
            },
            {
                path: "designation_categories",
                loadChildren: () =>
                    import(
                        "./pages/designation_categories/designation_categories.module"
                    ).then((m) => m.DesignationCatesModule),
            },

            {
                path: "designations",
                loadChildren: () =>
                    import("./pages/designations/designation.module").then(
                        (m) => m.DesignationModule
                    ),
            },
            {
                path: "countries",
                loadChildren: () =>
                    import("./pages/countries/country.module").then(
                        (m) => m.CountryModule
                    ),
            },
            {
                path: "cities",
                loadChildren: () =>
                    import("./pages/cities/city.module").then(
                        (m) => m.CityModule
                    ),
            },
            {
                path: "employees",
                loadChildren: () =>
                    import("./pages/employees/employee.module").then(
                        (m) => m.EmployeeModulesModule
                    ),
            },
            {
                path: "user-rights/:id",
                loadChildren: () =>
                    import("./pages/user-rights/user-rights.module").then(
                        (m) => m.UserRightsModule
                    ),
            },
            {
                path: "marital-status",
                loadChildren: () =>
                    import("./pages/marital_status/marital-status.module").then(
                        (m) => m.MaritalStatusModule
                    ),
            },
            {
                path: "education_level",
                loadChildren: () =>
                    import("./pages/education_level/education_level.module").then(
                        (m) => m.EducationLevelModule
                    ),
            },
            {
                path: "education_level_Degree",
                loadChildren: () =>
                    import("./pages/education_level_degree/education_level_degree.module").then(
                        (m) => m.EducationLevelDegreeModule
                    ),
            },
            {
                path: "religions",
                loadChildren: () =>
                    import("./pages/religions/religions.module").then(
                        (m) => m.ReligionsModule
                    ),
            },
            {
                path: "salary_category",
                loadChildren: () =>
                    import("./pages/salary_category/salary_category.module").then(
                        (m) => m.SalaryCategoryModule
                    ),
            },
            {
                path: "attandence_category",
                loadChildren: () =>
                    import("./pages/attandance_category/attandance_category.module").then(
                        (m) => m.AttandanceCategoryModule
                    ),
            },
            {
                path: "city_area",
                loadChildren: () =>
                    import("./pages/city_areas/city_areas.module").then(
                        (m) => m.CityAreaModule
                    ),
            },
            {
                path: "companies",
                loadChildren: () =>
                    import("./pages/companies/companies.module").then(
                        (m) => m.CompaniesModule
                    ),
            },
            {
                path: "defEmployeestatus",
                loadChildren: () =>
                    import("./pages/defemployee_statuses/defemployee_statuses.module").then(
                        (m) => m.DefEmployeeStatusModule
                    ),
            },
            {
                path: "account_level_1",
                loadChildren: () =>
                    import("./pages/ac_head_cat1/ac_head_cat1.module").then(
                        (m) => m.AcHeadCat1Module
                    ),
            },
            {
                path: "account_level_2",
                loadChildren: () =>
                    import("./pages/ac_head_cat2/ac_head_cat2.module").then(
                        (m) => m.AcHeadCat2Module
                    ),
            },
            {
                path: "account_level_3",
                loadChildren: () =>
                    import("./pages/achead_cat3/ac_head_cat3.module").then(
                        (m) => m.AcHeadCat3Module
                    ),
            },

            {
                path: "location_category",
                loadChildren: () =>
                    import("./pages/def_location_category/def_location_category.module").then(
                        (m) => m.DefLocationCategoryModule
                    ),
            },
            {
                path: "project_location",
                loadChildren: () =>
                    import("./pages/def_location/def_location.module").then(
                        (m) => m.DefLocationModule
                    ),
            },

            {
                path: "deployment_status",
                loadChildren: () =>
                    import("./pages/deployment_status/deployment_status.module").then(
                        (m) => m.DeploymentStatusModule
                    ),
            },
            {
                path: "allowance_type",
                loadChildren: () =>
                    import("./pages/allowancetypes/allowancetypes.module").then(
                        (m) => m.AllowancetypesModule
                    ),
            },
            {
                path: "def-sub-contractor-type",
                loadChildren: () =>
                    import("./pages/defsubcontractortypes/defsubcontractortypes.module").then(
                        (m) => m.DefSubContractorTypeModule
                    ),
            },
            {
                path: "sub-contractor-work-cat",
                loadChildren: () =>
                    import("./pages/subcontractorworkcategories/subcontractorworkcategories.module").then(
                        (m) => m.SubContractorWorkCategoryModule
                    ),
            },
            {
                path: "sub-contractor",
                loadChildren: () =>
                    import("./pages/sub_contractor/sub_contractor.module").then(
                        (m) => m.SubContractorModulesModule
                    ),
            },
            {
                path: "3rd-Person",
                loadChildren: () =>
                    import("./pages/ThirdPersons/ThirdPersons.module").then(
                        (m) => m.ThirdPersonsModule
                    ),
            },
            {
                path: "def-expense-category",
                loadChildren: () =>
                    import("./pages/defexpcategories/defexpcategories.module").then(
                        (m) => m.DefExpCategoryModule
                    ),
            },
            {
                path: "def-expense-head",
                loadChildren: () =>
                    import("./pages/defexphead/defexphead.module").then(
                        (m) => m.DefExpenseHeadModule
                    ),
            },
            {
                path: "def-expense-division",
                loadChildren: () =>
                    import("./pages/defexpensedivision/defexpensedivision.module").then(
                        (m) => m.DefExpenseDivisonModule
                    ),
            },
            {
                path: "bank",
                loadChildren: () =>
                    import("./pages/defbank/defbank.module").then(
                        (m) => m.DefBankModule
                    ),
            },
            {
                path: "bank_branch",
                loadChildren: () =>
                    import("./pages/defbankbranch/defbankbranch.module").then(
                        (m) => m.DefBankBranchModule
                    ),
            },
            {
                path: "bank_accountno",
                loadChildren: () =>
                    import("./pages/defbranchaccountno/defbranchaccountno.module").then(
                        (m) => m.DefBranchAccountnoModule
                    ),
            },
            {
                path: "cash-payment",
                loadChildren: () =>
                    import("./pages/cash_payment/cash_payment.module").then(
                        (m) => m.CashPaymentModule
                    ),
            },

            {
                path: "cash-reciept",
                loadChildren: () =>
                    import("./pages/cash_receipt/cash_receipt.module").then(
                        (m) => m.CashRecieptModule
                    ),
            },
            {
                path: "bank-payment",
                loadChildren: () =>
                    import("./pages/bank_payment/bank_payment.module").then(
                        (m) => m.BankPaymentModule
                    ),
            },

            {
                path: "bank-reciept",
                loadChildren: () =>
                    import("./pages/bank_receipt/bank_receipt.module").then(
                        (m) => m.BankRecieptModule
                    ),
            },
            {
                path: "journal-voucher",
                loadChildren: () =>
                    import("./pages/journal_voucher/journal_voucher.module").then(
                        (m) => m.JournalVoucherModule
                    ),
            },
            {
                path: "account-book",
                loadChildren: () =>
                    import("./pages/account_book/account_book.module").then(
                        (m) => m.AccountBookModule
                    ),
            },
            {
                path: "day-book",
                loadChildren: () =>
                    import("./pages/day_book/day_book.module").then(
                        (m) => m.DayBookModule
                    ),
            },
            {
                path: "ledger",
                loadChildren: () =>
                    import("./pages/ledger/ledger.module").then(
                        (m) => m.LedgerModule
                    ),
            },
            {
                path: "contractor-report",
                loadChildren: () =>
                    import("./pages/reports/finance_managment/contractors-report/contractors_report.module").then(
                        (m) => m.ContractorReportModule
                    ),
            },
            {
                path: "expense-report",
                loadChildren: () =>
                    import("./pages/reports/finance_managment/expense-report/expense_report.module").then(
                        (m) => m.ExpenseReportModule
                    ),
            },
            {
                path: "supplier-report",
                loadChildren: () =>
                    import("./pages/reports/finance_managment/supplier-report/supplier-report.module").then(
                        (m) => m.SuppliersReportModule
                    ),
            },
            {
                path: "thirdparty-report",
                loadChildren: () =>
                    import("./pages/reports/finance_managment/third_party-report/third_party-report.module").then(
                        (m) => m.ThirdPartyReportModule
                    ),
            },
            {
                path: "project-report",
                loadChildren: () =>
                    import("./pages/reports/finance_managment/project_report/project_report.module").then(
                        (m) => m.ProjectsReportModule
                    ),
            },
            {
                path: "banks-report",
                loadChildren: () =>
                    import("./pages/reports/finance_managment/bank_report/bank_report.module").then(
                        (m) => m.BanksReportModule
                    ),
            },
            {
                path: "userdefined-report",
                loadChildren: () =>
                    import("./pages/reports/finance_managment/user_defined-report/user_defined-report.module").then(
                        (m) => m.UserDefinedReportModule
                    ),
            },
            {
                path: "transaction-type",
                loadChildren: () =>
                    import("./pages/transaction_type/transaction_type.module").then(
                        (m) => m.TransactionTypeModule
                    ),
            },
            {
                path: "payroll",
                loadChildren: () =>
                    import("./pages/payroll/payroll.module").then(
                        (m) => m.PayRollModule
                    ),
            },
            {
                path: "hr",
                loadChildren: () =>
                    import("./pages/hr/hr.module").then(
                        (m) => m.HRModule
                    ),
            },
        ],
    },
    {
        path: "authentication",
        component: AuthLayoutComponent,
        loadChildren: () =>
            import("./pages/authentication/authentication.module").then(
                (m) => m.AuthenticationModule
            ),
    },
    { path: "**", component: Page404Component },
];
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule { }
